import React from 'react';
import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';
import { ButtonStyle } from 'styles/variable';

/**
 *
 * @param {string} title - the text is shown on the button
 * @param {string} size - small - medium - large
 * @param {function} onClick - handle function for Click event
 * @param {boolean} disabled - disabled button
 * @param {boolean} loading - loading button
 * @returns {JSX}
 */
const PrimaryButton = (props) => {
    const {
        title = '',
        size = 'medium',
        onClick,
        disabled,
        loading,
        width,
        wrapStyle = {}
    } = props;
    const handleOnClick = () => {
        if (onClick && typeof onClick === 'function') {
            onClick();
        }
    };

    const styles = ButtonStyle[size] || {};
    return (
        <ButtonContainer
            disabled={disabled}
            onClick={handleOnClick}
            width={width || styles.width}
            height={styles.height}
            inactive={disabled}
            style={wrapStyle}
        >
            <ButtonBackground>
                {loading ? (
                    <LoadingOutlined
                        style={{ fontSize: '20px', color: '#ffffff' }}
                    />
                ) : (
                    <ButtonText
                        fontSize={styles.fontSize}
                        letterSpacing={styles.letterSpacing}
                        lineHeight={styles.lineHeight}
                    >
                        {title}
                    </ButtonText>
                )}
            </ButtonBackground>
        </ButtonContainer>
    );
};

const ButtonContainer = styled.button`
    width: ${(props) => (props.width ? props.width : '190px')};
    border: none;
    height: ${(props) => (props.height ? props.height : '40px')};
    background-color: ${(props) => (!props.inactive ? '#19c0ff' : '#8A99A9')};
    background-repeat: no-repeat;
    overflow: hidden;
    outline: none;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
        background-color: ${(props) => !props.inactive && '#12AFEB'};
    };
`;

const ButtonText = styled.span`
    color: ${(props) => props.textColor || '#FFFFFF'};
    font-family: AvenirNext-DemiBold;
    font-size: ${(props) => props.fontSize || '11px'};
    letter-spacing: ${(props) => props.letterSpacing || '0.7px'};
    line-height: ${(props) => props.lineHeight || '13px'};
    text-align: center;
`;

const ButtonBackground = styled.div`
    background-color: transparent;
    display: flex;
    justify-content: center;
    padding-top: 2px;
`;

export default PrimaryButton;
